export const CHANGE_MODAL_VISIBILITY = 'changeModalVisibilityModals';

export const SEND_EMAIL_PENDING = 'sendEmailModalsPending';
export const SEND_EMAIL_FULFILLED = 'sendEmailModalsFulfilled';
export const SEND_EMAIL_REJECTED = 'sendEmailRejected';